module.exports = __webpack_public_path__ + "static/media/DDStakeholderSatisfactionSurvey.86a892fa.xlsx";